module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/pObxYu/tc-custom/9781429975346.jpg?1737748697527",
      "alt": "This image is the cover for the book Wild Turkey"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Wild Turkey\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Phil Landsdale has problems. He's out of a job, heis son's a pyromaniac, and his wife is running out of excuses as to why she comes home from work every night six hours late."), _c('br'), _c('br'), _vm._v("In his newly appointed house-husband position, Phil decides he has plenty of time to figure things out. And he learns when you have a lot of time on your hands, you begin to notice your neighbors, intricate nuances, and the upset balance if someone doesn't follow the same routine. . . . Like the long and sexy neighbor across the street, Cassandra Payne."), _c('br'), _c('br'), _vm._v("He's been keeping tabs on Cassandra with his new-found friend, Bryan, an ex-detective who lives next door. But when Cassandra's husband is gunned down en route from the airport, Phil and Bryan realize that beautiful Cassandra might be hiding more beneath that insee-weensy miniskirt than meets the eye. When the two go to investigate a stranger lurking around the Payne house, Bryan is almost killed and Phil finds himself drawn into the dark and mysterious world of Cassandra Payne."), _c('br'), _c('br'), _vm._v("With a bottle of bourbon and a full tank of gas, Phil sets out to find the gunman and discovers the truth in a world where some men are men, some are wild, and some only a turkey."), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v("At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Michael Hemmingson\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Tom Doherty Associates\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0